const baseUrl = "/rest";

export const REST_ENPOINTS = {
  uploadCountryImage: `${baseUrl}/uploadCountryImage`,
  uploadChatImage: `${baseUrl}/uploadMessageImage`,
  uploadBotProfileImage: `${baseUrl}/uploadProfileImage`,
};
